// extracted by mini-css-extract-plugin
export var article_tag = "tags-module--article_tag--4ca00";
export var taglist_name = "tags-module--taglist_name--a2b7e";
export var tags = "tags-module--tags--8a6e7";